import { render, staticRenderFns } from "./AssetCardDetail.vue?vue&type=template&id=5eba4bf7"
import script from "./AssetCardDetail.vue?vue&type=script&lang=js"
export * from "./AssetCardDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5eba4bf7')) {
      api.createRecord('5eba4bf7', component.options)
    } else {
      api.reload('5eba4bf7', component.options)
    }
    module.hot.accept("./AssetCardDetail.vue?vue&type=template&id=5eba4bf7", function () {
      api.rerender('5eba4bf7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/fixed-asset/AssetCardDetail.vue"
export default component.exports